import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white flex flex-col">
      <header className="px-4 sm:px-6 py-5">
        <Logo />
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center" data-testid="notfound">
          <p className="text-sm font-medium text-[#ff6b35] uppercase tracking-wider">404</p>
          <h1 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">Seite nicht gefunden</h1>
          <p className="mt-3 text-sm text-[#9a9aa3] max-w-sm mx-auto">
            Diese Adresse existiert nicht. Vielleicht der falsche Link?
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center h-10 px-4 rounded-lg bg-gradient-to-r from-[#ff6b35] to-[#ff3d6e] text-white text-sm font-semibold mt-6"
            data-testid="notfound-home-link"
          >
            Zur Startseite
          </Link>
        </div>
      </main>
    </div>
  );
}
